import { SearchScope } from './state';
import { SearchSuggestionPayload } from './actions';
import { Action } from 'redux';

export const SEARCH_QUERY = 'SEARCH_QUERY';
export const SEARCH_RESET = 'SEARCH_RESET';
export const SEARCH_SUGGESTIONS = 'SEARCH_SUGGESTIONS';
export const SEARCH_SUGGESTIONS_RESET = 'SEARCH_SUGGESTIONS_RESET';
export const SEARCH_QUERY_SELECTED_TOPHIT = 'SEARCH_QUERY_SELECTED_TOPHIT';
export const SEARCH_SCOPE_CHANGE = 'SEARCH_SCOPE_CHANGE';

export type SearchReset = Action<typeof SEARCH_RESET>;
export type SearchSuggestionsReset = Action<typeof SEARCH_SUGGESTIONS_RESET>;

export type SearchSuggestions = {
    type: typeof SEARCH_SUGGESTIONS;
    payload: SearchSuggestionPayload;
};

export type SearchScopeChange = {
    type: typeof SEARCH_SCOPE_CHANGE;
    payload: SearchScope;
};

export type SearchQuerySelectedTophit = {
    type: typeof SEARCH_QUERY_SELECTED_TOPHIT;
    payload: string;
};

export type SearchAction =
    | SearchReset
    | SearchSuggestions
    | SearchSuggestionsReset
    | SearchScopeChange
    | SearchQuerySelectedTophit;
